import { Link, useLocation } from "react-router-dom";
import { BrandMark } from "../components/BrandMark";

export default function Legal() {
  const { pathname } = useLocation();
  const isPrivacy = pathname.includes("privacy");
  return (
    <div className="min-h-screen bg-[#F6F3EC] px-6 py-10">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="flex items-center gap-2 mb-8"><BrandMark size={28} /><span className="font-display font-bold">BackPocket</span></Link>
        <h1 className="font-display text-3xl font-bold tracking-tight">{isPrivacy ? "Privacy Policy" : "Terms of Service"}</h1>
        <p className="text-[#25282E] mt-4 leading-relaxed">
          {isPrivacy
            ? "BackPocket is anonymous-by-default. Customer loyalty passes are issued with a random BackPocket identifier and contain no personal information. Businesses may optionally and voluntarily collect additional details with clear consent. We do not encode personal data into QR codes. Australian English and Australian Privacy Principles guide our approach."
            : "By using BackPocket you agree to operate your loyalty programs lawfully and fairly. BackPocket provides wallet-pass infrastructure via PassKit and billing via Stripe. Subscriptions renew monthly at A$49.99 unless cancelled."}
        </p>
        <p className="text-xs text-[#25282E]/60 mt-8">This document is a starting template and not legal advice. Last updated June 2026.</p>
      </div>
    </div>
  );
}
